'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'M16 2v14H2V2h14zm0-2H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z';